<template>
    <div class="sc04d_02 api">
        <div class="sc04d_icon">
            <a href="javascript.void(0)" :class="['iconall',{on: selectedDatasrcCate === ''}]"
                @click.prevent="selectDatasrcCate('')">
                <span>전체</span>
            </a>
            <a href="javascript.void(0)"
                v-for="(cate, index) in datasrcCateList" :class="[iconMap[cate.commonCode], {on: selectedDatasrcCate === cate.commonCode}]"
                @click.prevent="selectDatasrcCate(cate.commonCode)" :key="index">
                <span>{{cate.localeTitle}}</span>
            </a>
        </div>
    </div>
</template>

<script>
import {$_WC} from '@/confs/common.const.js';
import {mapGetters} from "vuex";
export default {
    data() {
        return {
            selectedDatasrcCate: '',
            iconMap: {
                '1': 'icon01', '2': 'icon02', '3': 'icon08', '4': 'icon04',
                '5': 'icon06', '6': 'icon03', '7': 'icon05', '9': 'icon07',
            },
            code: '',
        }
    },
    computed: {
        ...mapGetters({
            datasrcCateList: 'getDatasrcCateList',
            openApiTab: 'getOpenApiTab',
            selectedOpenApiTab: 'getSelectedOpenApiTab',
            errorReport: 'getErrorReport',
        }),
    },
    watch: {
        datasrcCateList: {
            immediate: false,
            handler: function (newVal, oldVal) {
                if($_WC.isMobile && newVal.length > 0) {
                    // this.selectDatasrcCate(newVal[0].commonCode);
                    this.selectDatasrcCate('');
                }
            }
        },
    },
    created() {
    },
    methods: {
        selectDatasrcCate(code) {
            if(this.selectedDatasrcCate == code) {
                this.selectedDatasrcCate = '';
                this.$eventBus.$emit('OpenapiTab::select-datasrc-cate', '');
            }else {
                this.selectedDatasrcCate = code;
                this.$eventBus.$emit('OpenapiTab::select-datasrc-cate', code);
            }
        },
    },
}
</script>
